import {useEffect} from 'react';
import {Outlet} from 'react-router';

const BaseLayout = () => {
  useEffect(() => {
    import('preline');
  }, []);

  return (
    <div className="h-full">
      <Outlet />
    </div>
  );
};

export default BaseLayout;
